// extracted by mini-css-extract-plugin
export default {"mainTitle":"MainTitle-module_mainTitle_kiMu2X"};